const HIDDEN_CLASS = "hidden";
const DISABLED_STYLES = ["opacity-50", "cursor-not-allowed", "pointer-events-none"];

// export async function disableButton(button: HTMLButtonElement, callback: () => Promise<void>, timeout: number = 1) {
//   if (button.disabled) return;
//
//   try {
//     button.disabled = true;
//     await callback()
//   } finally {
//     setTimeout(() => { button.disabled = false }, timeout)
//   }
// }

export function preventButtonDoubleClick<T extends any[], R>(
  element: HTMLElement,
  asyncFn: (...args: T) => Promise<R>,
  delay: number = 1000,
): (...args: T) => Promise<R | undefined> {
  return async function (...args: T): Promise<R | undefined> {
    if (!element) return;

    const isButton = element instanceof HTMLButtonElement;
    if (isButton) element.disabled = true;
    element.classList.add(...DISABLED_STYLES);

    try {
      await asyncFn(...args);
    } finally {
      if (isButton) {
        setTimeout(() => {
          element.disabled = false;
        }, delay);
      }
      element.classList.remove(...DISABLED_STYLES);
    }
  };
}

export function hideElement(el: HTMLElement) {
  el.classList.add(HIDDEN_CLASS);
}

export function showElement(el: HTMLElement) {
  el.classList.remove(HIDDEN_CLASS);
  if (el instanceof HTMLButtonElement) {
    el.disabled = false;
  }
}
